import ContentSyncMixin from '@/mixins/content-sync';
import ThemeMixin from '@/mixins/templates/theme';

import { syncStatus } from '@/helpers/contentSync';
import { parseDate } from '~/helpers/date';

export default {
  name   : 'AssociatedCoursesList',
  mixins : [ContentSyncMixin, ThemeMixin],
  props  : {
    tableItems: {
      type     : Array,
      default  : () => [],
      required : true
    }
  },
  data() {
    return {
      syncStatus,
      tableHeaders: [
        { text: this.$t('content.modalContentSync.syncSummary.associatedCourses.table.academicMainName'), value: 'academicMainName', sortable: false },
        { text: this.$t('content.modalContentSync.syncSummary.associatedCourses.table.syncStatus'), value: 'syncStatus', sortable: false, width: '35%' }
      ]
    };
  },
  methods: {
    getSyncStatusIcon(status) {
      return {
        [syncStatus.NOT_SYNCHRONIZED] : 'mdi-sync-off',
        [syncStatus.WAITING_FOR_SYNC] : 'mdi-timer-sync-outline',
        [syncStatus.SYNCHRONIZED]     : 'mdi-sync',
        [syncStatus.ERROR]            : 'mdi-cancel'
      }[status] || 'mdi-sync';
    },
    getSyncStatusText(status) {
      return {
        [syncStatus.NOT_SYNCHRONIZED] : this.$t('content.layout.timeline.course.associatedCoursesStatus.notSynchronized'),
        [syncStatus.WAITING_FOR_SYNC] : this.$t('content.layout.timeline.course.associatedCoursesStatus.waitingForSync'),
        [syncStatus.SYNCHRONIZED]     : this.$t('content.layout.timeline.course.associatedCoursesStatus.synchronized'),
        [syncStatus.ERROR]            : this.$t('content.layout.timeline.course.associatedCoursesStatus.error')
      }[status] || 'mdi-sync';
    },
    getSyncDate(date) {
      return parseDate(date, 'dd/MM/yyyy');
    }
  }
};
